import React from "react";
import { Container } from "@material-ui/core";
import { Link } from "react-router-dom";

const NAVY    = "#1A2B4A";
const GOLD    = "#C8991A";

const ChevronRight = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    style={{ flexShrink: 0 }}
  >
    <path d="M9 6l6 6-6 6z" />
  </svg>
);

export default function BreadCrumbOwn({ title, children, hideBottomDiv = false }) {
  return (
    <>
      <div className="bc-banner">
        <div className="bc-banner__overlay" />
        <Container className="bc-banner__inner">
          <span className="bc-banner__eyebrow">Rangia College</span>
          <h1 className="bc-banner__title">{title}</h1>
          <span className="bc-banner__rule" />
        </Container>
      </div>

      {children}

      {hideBottomDiv === false && (
        <div className="bc-crumbs">
          <Container className="bc-crumbs__inner">
            <Link to="/" className="bc-crumbs__link">Home</Link>
            <ChevronRight />
            <span className="bc-crumbs__current">{title}</span>
          </Container>
        </div>
      )}

      <style>{`
        .bc-banner {
          position: relative;
          min-height: 220px;
          display: flex;
          align-items: flex-end;
          background-image: url(/images/rangia_banner.jpeg);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-color: ${NAVY};
          border-bottom: 3px solid ${GOLD};
        }
        .bc-banner__overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg,
            rgba(26,43,74,0.35) 0%,
            rgba(26,43,74,0.78) 70%,
            rgba(26,43,74,0.92) 100%
          );
        }
        .bc-banner__inner {
          position: relative;
          z-index: 1;
          padding-top: 36px;
          padding-bottom: 26px;
          color: #fff;
          font-family: 'Lato', sans-serif;
        }
        .bc-banner__eyebrow {
          display: inline-block;
          color: ${GOLD};
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          margin-bottom: 8px;
        }
        .bc-banner__title {
          margin: 0;
          color: #fff;
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 30px;
          font-weight: 700;
          letter-spacing: 0.3px;
          line-height: 1.2;
        }
        .bc-banner__rule {
          display: block;
          width: 48px;
          height: 3px;
          background: ${GOLD};
          margin-top: 10px;
          border-radius: 2px;
        }

        .bc-crumbs {
          background: #fff;
          border-bottom: 1px solid #ece6d6;
        }
        .bc-crumbs__inner {
          display: flex;
          align-items: center;
          gap: 8px;
          padding-top: 12px;
          padding-bottom: 12px;
          font-family: 'Lato', sans-serif;
          font-size: 12.5px;
          color: ${GOLD};
        }
        .bc-crumbs__link {
          color: ${NAVY};
          text-decoration: none;
          font-weight: 600;
          letter-spacing: 0.3px;
          transition: color 0.15s;
        }
        .bc-crumbs__link:hover {
          color: ${GOLD};
        }
        .bc-crumbs__current {
          color: #6b7280;
          font-weight: 500;
        }

        @media (max-width: 600px) {
          .bc-banner { min-height: 180px; }
          .bc-banner__title { font-size: 24px; }
          .bc-banner__inner { padding-top: 28px; padding-bottom: 20px; }
        }
      `}</style>
    </>
  );
}
